import AppMedia from '@/components/App/AppMedia.vue'

const Media = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-media', AppMedia)
    Vue.prototype.$media = {
      add(params) {
        Media.EventBus.$emit('add', params)
      },
      edit(params) {
        Media.EventBus.$emit('edit', params)
      },
      remove(params) {
        Media.EventBus.$emit('remove', params)
      }
    }
  }
}

export default Media